import Masonry from 'masonry-layout';

export function setupResourceCards() {
  const resourceCards = document.querySelector('.js-resource-cards');

  if (!resourceCards) {
    return false;
  }

  resourceCards.classList.add('masonry-active');

  // eslint-disable-next-line;
  const resourcesMasonry = new Masonry(resourceCards, {
    itemSelector: '.js-resource-card',
    columnWidth: '.js-card-sizer',
    percentPosition: true,
    gutter: '.js-gutter-sizer',
  });

  return resourcesMasonry;
}

window.addEventListener('DOMContentLoaded', function () {
  setupResourceCards();
});
